import { useContext } from "react";
import { QuizContext } from "~/providers/QuizProvider";

export const useQuizContext = () => {
  return useContext(QuizContext);
};
